<!-- src/app/components/order-tracking/order-tracking.component.html -->
<div class="max-w-5xl mx-auto p-6">
  <div class="flex items-center justify-between mb-6">
    <h1 class="text-2xl font-semibold">Tracking Details</h1>
    <div class="flex items-center gap-3">
      <button (click)="goBack()" class="px-3 py-1 rounded bg-gray-100 hover:bg-gray-200">Back</button>
    </div>
  </div>

  <div *ngIf="loading" class="py-12 text-center text-gray-500">Loading tracking details...</div>

  <div *ngIf="error" class="p-4 bg-red-50 border border-red-100 rounded text-red-700">{{ error }}</div>

  <div *ngIf="tracking" class="space-y-6">
    <!-- header info -->
    <div class="bg-white p-4 rounded shadow-sm flex justify-between items-start">
      <div>
        <div class="text-sm text-gray-500">Courier Info</div>
        <div class="font-medium">{{ tracking.courier?.partnerName || '—' }}</div>
        <div class="text-sm text-gray-500">{{ tracking.courier?.contact || '' }}</div>
      </div>

      <div class="text-right">
        <div class="text-sm text-gray-500">Tracking Number</div>
        <div class="text-blue-600 font-medium">{{ tracking.trackingNumber }}</div>
      </div>
    </div>

    <!-- stepper -->
    <div class="bg-white p-6 rounded shadow-sm">
      <div class="flex items-center justify-between">
        <ng-container *ngFor="let step of STEPS; let i = index">
          <div class="flex-1 flex flex-col items-center text-center">
            <div class="w-12 h-12 rounded-full flex items-center justify-center mb-2"
                 [ngClass]="{
                 'bg-green-600 text-white' : i <= stepIndex(tracking.currentStatus),
                'bg-gray-100 text-gray-600': i > stepIndex(tracking.currentStatus)
              }"
            >
              <!-- simple icon -->
              <svg *ngIf="step==='Processing'" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 7h18M3 12h18M3 17h18"/>
              </svg>
              <svg *ngIf="step==='Packed'" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M20 12H4"/>
              </svg>
              <svg *ngIf="step==='Shipped'" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 10l1.5-3h15L21 10v6a2 2 0 01-2 2h-1a3 3 0 11-6 0H9a3 3 0 11-6 0H2v-8z"/>
              </svg>
              <svg *ngIf="step==='Delivered'" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M5 13l4 4L19 7"/>
              </svg>
            </div>

            <div class="text-sm font-medium" [ngClass]="{ 'text-gray-700': i <= stepIndex(tracking.currentStatus), 'text-gray-400': i > stepIndex(tracking.currentStatus) }">
              {{ step }}
            </div>

            <!-- connector line -->
            <div *ngIf="i < STEPS.length - 1" class="w-full">
              <div class="h-1 mt-3"
                   [ngClass]="{ 'bg-green-400': i < stepIndex(tracking.currentStatus), 'bg-gray-200': i >= stepIndex(tracking.currentStatus) }"></div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- timeline list -->
    <div class="bg-white p-6 rounded shadow-sm">
      <ul class="space-y-6">
        <li *ngFor="let ev of tracking.events" class="flex">
          <div class="w-24 text-right pr-6">
            <div class="text-sm text-gray-500">{{ formatDate(ev.timestamp) }}</div>
            <div class="text-xs text-gray-400">{{ relativeTime(ev.timestamp) }}</div>
          </div>
          <div class="flex-1">
            <div class="flex items-center justify-between">
              <div>
                <div class="font-semibold">{{ ev.title }}</div>
                <div class="text-sm text-gray-500">{{ ev.description }}</div>
                <div *ngIf="ev.location" class="text-xs text-gray-400 mt-1">{{ ev.location }}</div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
